import { render } from "./FoundValueOrigins.vue?vue&type=template&id=6e178d7c&ts=true"
import script from "./FoundValueOrigins.vue?vue&type=script&lang=ts"
export * from "./FoundValueOrigins.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__